var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.947266,
    y: 0.947021,
    width: 134.106,
    height: 134.106,
    rx: 67.0529,
    fill: "#575E76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 41.3333C69.5 40.5048 68.8284 39.8333 68 39.8333C67.1716 39.8333 66.5 40.5048 66.5 41.3333H69.5ZM66.5 41.3333V43.9999H69.5V41.3333H66.5Z",
    fill: "#272A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 65.3333C69.5 64.5048 68.8284 63.8333 68 63.8333C67.1716 63.8333 66.5 64.5048 66.5 65.3333H69.5ZM66.5 65.3333V67.9999H69.5V65.3333H66.5Z",
    fill: "#272A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89.3333C69 88.781 68.5523 88.3333 68 88.3333C67.4477 88.3333 67 88.781 67 89.3333H69ZM67 89.3333V94.6666H69V89.3333H67Z",
    fill: "#272A39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3332 94.6667H62.6665",
    stroke: "#272A39",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54.6667H76",
    stroke: "#272A39",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 78.6667H76",
    stroke: "#272A39",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8773 45.3333H82.6666C86.4119 45.3333 88.2845 45.3333 89.6297 46.2321C90.212 46.6212 90.712 47.1212 91.1011 47.7035C92 49.0487 92 50.9214 92 54.6666C92 58.4118 92 60.2844 91.1011 61.6296C90.712 62.212 90.212 62.712 89.6297 63.1011C88.2845 63.9999 86.4119 63.9999 82.6666 63.9999H53.8773C52.1238 63.9999 51.247 63.9999 50.4425 63.7381C50.0875 63.6225 49.7457 63.47 49.4226 63.2831C48.6902 62.8595 48.1044 62.2071 46.9328 60.9024C44.6643 58.3761 43.53 57.1129 43.2569 55.6367C43.1383 54.9954 43.1383 54.3378 43.2569 53.6964C43.53 52.2202 44.6643 50.9571 46.9328 48.4307C48.1044 47.1261 48.6902 46.4737 49.4226 46.05C49.7457 45.8631 50.0875 45.7107 50.4425 45.5951C51.247 45.3333 52.1238 45.3333 53.8773 45.3333Z",
    stroke: "#272A39",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1227 69.3333H53.3333C49.5881 69.3333 47.7155 69.3333 46.3703 70.2321C45.7879 70.6212 45.2879 71.1212 44.8988 71.7035C44 73.0487 44 74.9214 44 78.6666C44 82.4118 44 84.2844 44.8988 85.6296C45.2879 86.212 45.7879 86.712 46.3703 87.1011C47.7155 87.9999 49.5881 87.9999 53.3333 87.9999H82.1227C83.8762 87.9999 84.7529 87.9999 85.5575 87.7381C85.9125 87.6225 86.2543 87.47 86.5774 87.2831C87.3098 86.8595 87.8956 86.2071 89.0671 84.9024C91.3357 82.3761 92.4699 81.1129 92.743 79.6367C92.8617 78.9954 92.8617 78.3378 92.743 77.6964C92.4699 76.2202 91.3357 74.9571 89.0671 72.4307C87.8956 71.1261 87.3098 70.4737 86.5774 70.05C86.2543 69.8631 85.9125 69.7107 85.5575 69.5951C84.7529 69.3333 83.8762 69.3333 82.1227 69.3333Z",
    stroke: "#272A39",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup1);
export default __webpack_public_path__ + "static/media/startup-1.37daee2873e0b81b1759e8d6128668ed.svg";
export { ForwardRef as ReactComponent };